import { SmartMeterSectionDataP6022 } from './Data/P6022/P6022.data';

export const selectSmartMeterSectionData = (selectedTag, formName, formData) => {
    let filterViewData = { rows: [] };
    if ((['P6-22', 'P7-22', 'P7-15', 'P7-14', 'P7-18', 'P6-12', 'P7-29', 'P8-8.1', 'P8-12.1', 'P7-30', 'P6-27', 'P6-31']).includes(formName)) {
        filterViewData = SmartMeterSectionDataP6022(formData, formName);
    }
    return filterViewData;
};
